export enum ContactBalanceSortProperty {
  AverageRange = '16-30',
  ContactName = 'contact_name',
  LongRange = '31+',
  NotOverdue = 'notOverdue',
  ShortRange = '0-15',
}
